import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class WooCommerceSeasonMapApiClient extends AdvancedApiClient {

    static entityType = "WooCommerceSeasonMap"

    constructor(token, seasonId, id) {
        super();

        this.setEntityType(WooCommerceSeasonMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/season/{sid}/woocommerce-map/{id}")
                .setRouteParam("sid", seasonId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/season/{sid}/woocommerce-map")
                .setRouteParam("sid", seasonId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}